import React, { forwardRef } from "react";

import Tag, { TagProps } from "antd/es/tag";
import cn from "classnames";

import styles from "./Chip.module.scss";

export interface ChipProps extends TagProps {
  clickable?: boolean;
  icon?: React.ReactNode;
  iconPosition?: "end" | "start";
  inline?: boolean;
  noPadding?: boolean;
  type?: "closable" | "disabled" | "label" | "light";
}

const Chip = forwardRef<HTMLDivElement, ChipProps>(
  (
    {
      children,
      className,
      clickable,
      icon,
      iconPosition = "start",
      inline,
      noPadding,
      onClick,
      type = "label",
      ...restProps
    },
    ref
  ) => {
    const cursorPointer = clickable ?? !!onClick;

    return (
      <Tag
        {...restProps}
        className={cn(
          styles.container,
          styles[type],
          {
            [styles.inline]: inline,
            [styles.noPadding]: noPadding,
            [styles.pointer]: cursorPointer,
          },
          className
        )}
        onClick={onClick}
        ref={ref}
      >
        {iconPosition === "start" && icon}
        {children}
        {iconPosition === "end" && icon}
      </Tag>
    );
  }
);

export default Chip;
